import React, { useState } from "react";
import "../FeedbackPopUp/feedbackPopup.css";

// not selected
import Inaccurate from "../../Images/FeedbackThum/Inaccurate1.svg";
import OutOfDate from "../../Images/FeedbackThum/OutOfDate1.svg";
import ToShort from "../../Images/FeedbackThum/ToShort1.svg";
import ToLong from "../../Images/FeedbackThum/ToLong1.svg";
import Harmful from "../../Images/FeedbackThum/Harmful1.svg";
import NotHelpful from "../../Images/FeedbackThum/NotHelpful1.svg";




import CloseButton from "../../Images/closeButton.svg";
import apiService from "../../Services/apiServices";



const feedbackOptions = [
  { id: 1, src: Inaccurate, name: "Inaccurate" },
  { id: 2, src: OutOfDate, name: "Out Of Date" },
  { id: 3, src: ToShort, name: "Too Short" },
  { id: 4, src: ToLong, name: "Too Long" },
  { id: 5, src: Harmful, name: "Harmful or Offensive" },
  { id: 6, src: NotHelpful, name: "Not Helpful" },
];

function FeedbackPopUp({ setIsFeedbackPop, showMaximumChat,sessionId,setCheckThumsDownFeedback ,messages , index ,checkThumsDownFeedback  }) {
  const [selectedItem, setSelectedItem] = useState({});
  const [submitButtonDisable, setSubmitButtonDisable] = useState(true);
  const [thankYouNote, setThankYouNote] = useState(false);
  const [activeOption, setActiveOption] = useState(null);
  const [feedBackInput , setFeedBackInput] = useState('');

  const [selectedOptions, setSelectedOptions] = useState({});

  const handleClick = (optionId) => {
    setSelectedOptions((prevState) => {
      const newSelectedOptions = { ...prevState };
      if (newSelectedOptions[optionId]) {
        delete newSelectedOptions[optionId];
      } else {
        newSelectedOptions[optionId] = true;
      }
      setSubmitButtonDisable(Object.keys(newSelectedOptions).length === 0);
      return newSelectedOptions;
    });
  };

  

  const handleSubmitButton = () => {
    setThankYouNote(true);
    // index === messages?.length - 1  && 
    setCheckThumsDownFeedback([...checkThumsDownFeedback ,index])
    
    const optionsSelected = feedbackOptions
      .filter((item) => selectedOptions[item.id])
      .map((item) => item.name);

    apiService.feedbackApi({
      feedbackThumbs: 'thumbsDown',
      feedbackOptions: optionsSelected.join(","),
      feedbackResponse: feedBackInput,
      sessionId:sessionId
    });

    setTimeout(() => {
      setIsFeedbackPop(false);
    }, 3000);
  };

  const maximum = () => {
    return (
      <div>
        <div className="feedback-overlay"></div>
        {thankYouNote ? (
          thankYou()
        ) : (
          <div className="feedback-popup">
            {/* /top */}
            <div className="feedback-popup-header">
              <span className="popup-row-one">
                <div className="popup-help">Help us improve </div>
                <img
                  src={CloseButton}
                  onClick={() => setIsFeedbackPop(false)}
                  style={{
                    position: "absolute",
                    width: "24px",
                    height: "24px",
                    top: "18px",
                    right: "10px",
                  }}
                ></img>
              </span>
              <span className="popup-sub">
                Provide additional feedback on this answer. Select all the
                apply.
              </span>
            </div>

            {/* middle */}
            <div className="feedback-popup-content">
              <div className="feedback-popup-options">
                <div
                  className="feedback-popup-option"
                  style={{
                    display: "flex",
                    flexWrap :'wrap',
                    gridTemplateColumns: "1fr 1fr",
                    gridColumnGap: "8px",
                    gridRowGap: "14px",
                    border: "1px",
                    borderRadius: "4px",
                  }}
                >
                   {feedbackOptions.map((option) => (
                    <button
                      key={option.id}
                      className={`feedback-button ${
                        selectedOptions[option.id] ? "active" : ""
                      }`}
                      onClick={() => handleClick(option.id)}
                    >
                      <img src={option?.src} alt={option?.name} className="icon" />
                      <span style={{color :'#220046'}}>{option?.name}</span>
                    </button>
                  ))}
                </div>
                <div className="feedback-popup-comment">
                  <div className="feedback-res">
                    How can be response improve? (optional){" "}
                  </div>
                  <input
                    style={{
                      width: "568px",
                      borderRadius: "32px",
                      height: "37.6px",
                      boxSizing: "border-box",
                      padding: "10px 16px",
                      marginTop: "8px",
                      fontSize: "14px",
                      border: "1px solid #ccc",
                    }}
                    onChange={(e) => setFeedBackInput(e?.target?.value) }
                    placeholder="Write your feedback..."
                  ></input>
                </div>
              </div>
            </div>

            {/* bottom */}
            <div className="feedback-popup-footer">
              <div className="feedback-popup-button">
                <button
                  className="feedback-btn-submit"
                  type={"submit"}
                  onClick={() => handleSubmitButton()}
                  disabled={submitButtonDisable}
                >
                  Submit
                </button>
                <button
                  className="feedback-btn-cancel"
                  onClick={() => setIsFeedbackPop(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const thankYou = () => {
    return <div className={showMaximumChat ? 'thank-you-max' : "thank-you"}>Thank you for your feedback</div>;
  };

  const minimumChat = () => {
    return (
      <div
        style={{
          width: "90%",
          border: "1px solid #E1E1E1",
          borderRadius: "8px",
          marginTop: "12px",
          marginLeft: "36px",
        }}
      >
        {thankYouNote ? (
          thankYou()
        ) : (
          <>
            <div style={{ width: "90%" }} className="feedback-popup-header">
              <span className="popup-row-one-mini">
                <div className="popup-help">Help us improve</div>
                {/* <img src={CloseButton} onClick={() => setIsFeedbackPop(false)}
                      style={{ height: '24px', top: '18px', right: '10px' }}
                  ></img> */}
              </span>
              <span className="popup-sub">
                Provide additional feedback on this answer. Select all that
                apply.
              </span>
            </div>

            <div style={{ width: "90%" }} className="feedback-popup-content">
              <div className="feedback-popup-options">
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "16px",
                    border: "1px #E1E1E1",
                    borderRadius: "4px",
                    width: "100%",
                    paddingBottom: "10px",
                    marginTop: "16px",
                  }}
                >
                  {feedbackOptions.map((option) => (
                    <button
                      key={option.id}
                      className={`feedback-button ${
                        selectedOptions[option.id] ? "active" : ""
                      }`}
                      onClick={() => handleClick(option.id)}
                    >
                      <img src={option?.src} alt={option?.name} className="icon" />
                      <span style={{color :'#220046'}}>{option?.name}</span>
                    </button>
                  ))}
                </div>
                <div className="feedback-popup-comment">
                  <div className="feedback-res">
                    How can the response be improved? (optional)
                  </div>
                  <input
                    style={{
                      width: "100%",
                      borderRadius: "32px",
                      height: "37.6px",
                      boxSizing: "border-box",
                      padding: "10px 16px",
                      marginTop: "8px",
                      fontSize: "14px",
                      border: "1px solid #ccc",
                    }}
                    onChange={(e) => setFeedBackInput(e?.target?.value) }
                    placeholder="Write your feedback..."
                  ></input>
                </div>
              </div>
            </div>

            <div style={{ height: "70px" }} className="feedback-popup-footer">
              <div className="feedback-popup-button">
                <button
                  className="feedback-btn-submit"
                  type="submit"
                  onClick={() => handleSubmitButton()}
                  disabled={submitButtonDisable}
                >
                  Submit
                </button>
                <button
                  className="feedback-btn-cancel"
                  onClick={() => setIsFeedbackPop(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    );
  };

  return <>{showMaximumChat ? maximum() : minimumChat()}</>;
}

export default FeedbackPopUp;
